import { render } from "./CaseDetailView.vue?vue&type=template&id=6a558695&scoped=true"
import script from "./CaseDetailView.vue?vue&type=script&lang=js"
export * from "./CaseDetailView.vue?vue&type=script&lang=js"

import "./CaseDetailView.vue?vue&type=style&index=0&id=6a558695&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a558695"]])

export default __exports__